export default __webpack_public_path__ + "static/media/SALONI_RESUME.cd6a3d27.pdf";